if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        // Prefer the visible quick-add__submit button; fall back to any submit button
        this.submitButton =
          this.querySelector('[type="submit"].quick-add__submit') ||
          this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        // Also grab the SVG plus button if present (upsell cards)
        this.svgAddButton = this.querySelector('[type="submit"].quick-add_button_svg');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        const ageCheckbox = this.form.querySelector('#i-am-over-18-years-of-age');

        if (ageCheckbox && !ageCheckbox.checked) {
          this.handleErrorMessage('Please confirm that you are over 18 years of age.');
          ageCheckbox.focus();
          return;
        }
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        // Show spinner — on the SVG button if it exists, otherwise the main button
        const spinnerHost = this.svgAddButton || this.submitButton;
        const spinner = spinnerHost.querySelector('.loading__spinner') ||
                        this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        // Show loading state on the SVG + button
        if (this.svgAddButton) {
          this.svgAddButton.setAttribute('aria-disabled', true);
          this._svgOriginal = this.svgAddButton.innerHTML;
          this.svgAddButton.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"
                 style="animation:sp-spin 0.7s linear infinite;display:block;">
              <circle cx="15" cy="15" r="11" stroke="white" stroke-width="2.5" stroke-dasharray="50 20" fill="none"/>
            </svg>
            <style>@keyframes sp-spin{to{transform:rotate(360deg)}}</style>`;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              //window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                openUpsellPopup();
                if (this.shouldOpenUpsellPopup) {
                  window.openFirstPopup();
                }
              });
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal[open]');

            if (this.svgAddButton && quickAddModal) {
              // ── Upsell + button: render cart silently, show ✓ checkmark ──
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response, true); // true = skip open
              });
              this.svgAddButton.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                  <rect x="1.25" y="1.25" width="27.5" height="27.5" stroke="#fff" stroke-width="2.5"/>
                  <path d="M8 15.5L13 20.5L22 10" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`;
              setTimeout(() => {
                if (this._svgOriginal) this.svgAddButton.innerHTML = this._svgOriginal;
                this.svgAddButton.removeAttribute('aria-disabled');
              }, 2000);

            } else if (quickAddModal) {
            CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(response, true); // true = skip open
            });
            if (this.submitButton) {
              const originalText = this.submitButtonText ? this.submitButtonText.textContent : '';
              const originalBg  = this.submitButton.style.backgroundColor;
              const originalColor = this.submitButton.style.color;

              // Flash yellow + black
              this.submitButton.style.backgroundColor = '#FFEA00';
              this.submitButton.style.color = '#000000';
              this.submitButton.classList.add("active");
              if (this.submitButtonText) {
                this.submitButtonText.textContent = window.variantStrings?.added || 'Added to cart';
              }

              setTimeout(() => {
                this.submitButton.style.backgroundColor = originalBg;
                this.submitButton.style.color = originalColor;
                this.submitButton.classList.remove("active");
                if (this.submitButtonText) {
                  this.submitButtonText.textContent = originalText;
                }
              }, 2000);
            }

            // } else {
            //   // ── Normal add to cart: render cart and open drawer ──
            //   CartPerformance.measure("add:paint-updated-sections", () => {
            //     this.cart.renderContents(response);
            //   });
            // }
            } else {
            const isMobile = window.matchMedia('(max-width: 767px)').matches;
            const hasUpsellPopup = !!document.getElementById('upsellPopup');

            if (isMobile && hasUpsellPopup) {
              // Gifting page on mobile: stay on the page so the upsell pop-up can show.
              // Update the cart drawer silently (true = skip open).
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response, true);
              });
            } else if (isMobile) {
              window.location.href = routes.cart_url;
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
            // Stay on the current page on both desktop and mobile.
            // If a cart drawer exists, update it. Otherwise, do nothing.
            // if (this.cart) {
            //   CartPerformance.measure("add:paint-updated-sections", () => {
            //     this.cart.renderContents(response);
            //   });
            // }
          }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');

            // Restore SVG button spinner if error occurred
            if (this.error && this.svgAddButton && this._svgOriginal) {
              this.svgAddButton.innerHTML = this._svgOriginal;
              this.svgAddButton.removeAttribute('aria-disabled');
            }

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}